// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container___ZUv4m{width:calc(50% - 16px);margin-left:16px}\n", "",{"version":3,"sources":["webpack://./src/routes/Reports/components/TransactionValueDashlet/TransactionValueDashlet.css"],"names":[],"mappings":"AAAA,mBACI,sBAAA,CACA,gBAAA","sourcesContent":[".container {\n    width: calc(50% - 16px);\n    margin-left: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "container___ZUv4m"
};
export default ___CSS_LOADER_EXPORT___;
